export default function doLog(key: string, ext?: string, type = 'CLK') {
  const { goldlog } = window as any;
  if (goldlog) {
    goldlog.record(key, type, ext);
  } else {
    // 初始化调用未加载log组件
    const q = window.goldlog_queue || (window.goldlog_queue = []);
    q.push({
      action: 'goldlog.record',
      arguments: [key, type, ext, 'POST'],
    });
  }
}
